import { Component, OnInit, Input, SimpleChanges, OnChanges, EventEmitter, Output, Inject, OnDestroy, forwardRef } from '@angular/core';
import { FormGroup, FormControl, Validators} from '@angular/forms';

import { DatexFormControl } from './models/datex-form-control';
import { 
  TextBoxModel, 
  NumberBoxModel, 
  SelectBoxModel, 
  ESelectBoxType,
  DateBoxModel, 
  CheckBoxModel, 
  TextModel, 
  LabelModel, 
  ButtonModel,
  SplitButtonModel,
  SeparatorModel,
  ImageModel,
  DrawModel,
  CodeBoxModel,
  ButtonStyles 
} from './models/control';
import { GridHeaderModel, GridCellModel, GridRowModel, CellStyles, GridContainerStyle, HeaderStyles } from './models/grid'
import { FieldModel } from './models/field'
import { ToolModel } from './models/tool';
import { Styles, ControlContainerStyles } from './models/style';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { isEqual, isNil, set } from 'lodash-es';
import { GridComponent, ELoadingStatus } from './components/grid.component';
import { BaseComponent } from './components/base.component';
import { WorkBook, read as readExcelFile, writeFile as writeExcelFile, utils as excelUtils } from 'xlsx';

import { SharedModule } from './shared.module';

import { UtilsService } from './utils.service';
import { SettingsValuesService } from './settings.values.service';
import { FootprintManager_ShellService } from './FootprintManager.shell.service';
import { FootprintManager_OperationService } from './FootprintManager.operation.service';
import { FootprintManager_DatasourceService } from './FootprintManager.datasource.index';
import { FootprintManager_FlowService } from './FootprintManager.flow.index';
import { FootprintManager_ReportService } from './FootprintManager.report.index';
import { FootprintManager_LocalizationService } from './FootprintManager.localization.service';
import { FootprintManager_shipping_container_tasks_child_grid_ComponentContextService } from './FootprintManager.shipping_container_tasks_child_grid.component.context.service';
import { Language } from './localization.service';
import { JobStatus } from './common-interfaces'
import { ApplicationType, ComponentType } from './app-context.service';
import { CleanupLoggerService } from './cleanup.logging.service';
import { $frontendTypes} from './FootprintManager.frontend.types'
import { $frontendTypes as $types} from './FootprintManager.frontend.types' 

import { EModalSize, EToasterType, EToasterPosition } from 'wavelength-ui';
import { ShippingContainers_task_dates_dd_singleComponent } from './ShippingContainers.task_dates_dd_single.component'


interface IFootprintManager_shipping_container_tasks_child_gridComponentEntity {
  Id?: number, ActualInventoryAmount?: number, ActualInventoryAmountPackId?: number, ActualPackagedAmount?: number, ActualPackagedPackId?: number, ActualSourceLicensePlateId?: number, ActualSourceLocationId?: number, ActualSourceShippingContainerId?: number, ActualTargetLicensePlateId?: number, ActualTargetLocationId?: number, ActualTargetShippingContainerId?: number, ChainHead?: number, CompletedDateTime?: string, CreatedSysDateTime?: string, CreatedSysUser?: string, Employee?: string, ExpectedInventoryAmount?: number, ExpectedInventoryAmountPackId?: number, ExpectedPackagedAmount?: number, ExpectedPackagedPackId?: number, ExpectedSourceLocationId?: number, ExpectedSourceShippingContainerId?: number, ExpectedTargetLocationId?: number, ExpectedTargetShippingContainerId?: number, LotId?: number, MaterialId?: number, ModifiedSysDateTime?: string, ModifiedSysUser?: string, Notes?: string, OperationCodeId?: number, OrderId?: number, ProjectId?: number, ShipmentId?: number, StartDateTime?: string, StatusId?: number, VendorLotId?: number, WarehouseId?: number, Status?: { Name?: string }, OperationCode?: { Name?: string }, Order?: { LookupCode?: string }, Shipment?: { LoadContainerId?: number, LookupCode?: string, LoadContainer?: { LookupCode?: string } }, ActualSourceShippingContainer?: { LookupCode?: string }, ActualTargetShippingContainer?: { LookupCode?: string }, ExpectedSourceShippingContainer?: { LookupCode?: string }, ExpectedTargetShippingContainer?: { LookupCode?: string }, ActualPackagedPack?: { Name?: string }, Warehouse?: { Name?: string }, ActualSourceLocation?: { Name?: string }, ActualTargetLocation?: { Name?: string }, ExpectedSourceLocation?: { Name?: string }, ExpectedTargetLocation?: { Name?: string }, Material?: { LookupCode?: string }, Lot?: { LookupCode?: string }, VendorLot?: { LookupCode?: string }, Project?: { Name?: string, OwnerId?: number, Owner?: { Name?: string } }}

interface IFootprintManager_shipping_container_tasks_child_gridComponentInParams {
  shippingContainerId: number, chainHead?: number}


class FootprintManager_shipping_container_tasks_child_gridComponentRowModel extends GridRowModel {
  grid: FootprintManager_shipping_container_tasks_child_gridComponent;
  entity: IFootprintManager_shipping_container_tasks_child_gridComponentEntity;



 // temporarily put required on all edit controls
  override formGroup = new FormGroup({
  });

  override cells = {
    Id: null,
    OperationCode: null,
    Status: null,
    Owner: null,
    Project: null,
    Material: null,
    VendorLot: null,
    Lot: null,
    ActualSourceShippingContainer: null,
    ActualTargetShippingContainer: null,
    ExpectedSourceShippingContainer: null,
    ExpectedTargetShippingContainer: null,
    OrderLookupCode: null,
    LoadContainerLookupCode: null,
    StartDateTime: null,
    CompletedDateTime: null,
    Employee: null,
    ExpectedPackagedAmount: null,
    ActualPackagedAmount: null,
    ActualPackaging: null,
    WarehouseName: null,
    Notes: null,
    ActualSourceLocation: null,
    ActualTargetLocation: null,
    ExpectedSourceLocation: null,
    ExpectedTargetLocation: null,
    CreatedDateTime: null,
    CreatedBy: null,
    ModifiedDateTime: null,
    ModifiedBy: null,
  }



  constructor(
    grid: FootprintManager_shipping_container_tasks_child_gridComponent,
    private $utils: UtilsService,
private $settings: SettingsValuesService,
private $shell: FootprintManager_ShellService,
private $datasources: FootprintManager_DatasourceService,
private $flows: FootprintManager_FlowService,
private $reports: FootprintManager_ReportService,
private $localization: FootprintManager_LocalizationService,
private $operations: FootprintManager_OperationService,
private $logger: CleanupLoggerService,
private $context: FootprintManager_shipping_container_tasks_child_grid_ComponentContextService,
) {
    super();

    this.grid = grid;

    this.cells.Id = new GridCellModel(
      new CellStyles(null, null),
      this.grid.headers.Id,
      new TextModel(null, null, null, null, null)
,
null
      );
    
    this.cells.OperationCode = new GridCellModel(
      new CellStyles(null, null),
      this.grid.headers.OperationCode,
      new TextModel(null, null, null, null, null)
,
null
      );
    
    this.cells.Status = new GridCellModel(
      new CellStyles(null, null),
      this.grid.headers.Status,
      new TextModel(null, null, null, null, null)
,
null
      );
    
    this.cells.Owner = new GridCellModel(
      new CellStyles(null, null),
      this.grid.headers.Owner,
      new TextModel(null, null, null, null, null)
,
null
      );
    
    this.cells.Project = new GridCellModel(
      new CellStyles(['grid-table-cell-link'], null),
      this.grid.headers.Project,
      new TextModel(null, null, null, null, null)
,
null
      );
    
    this.cells.Material = new GridCellModel(
      new CellStyles(['grid-table-cell-link'], null),
      this.grid.headers.Material,
      new TextModel(null, null, null, null, null)
,
null
      );
    
    this.cells.VendorLot = new GridCellModel(
      new CellStyles(null, null),
      this.grid.headers.VendorLot,
      new TextModel(null, null, null, null, null)
,
null
      );
    
    this.cells.Lot = new GridCellModel(
      new CellStyles(['grid-table-cell-link'], null),
      this.grid.headers.Lot,
      new TextModel(null, null, null, null, null)
,
null
      );
    
    this.cells.ActualSourceShippingContainer = new GridCellModel(
      new CellStyles(['grid-table-cell-link'], null),
      this.grid.headers.ActualSourceShippingContainer,
      new TextModel(null, null, null, null, null)
,
null
      );
    
    this.cells.ActualTargetShippingContainer = new GridCellModel(
      new CellStyles(['grid-table-cell-link'], null),
      this.grid.headers.ActualTargetShippingContainer,
      new TextModel(null, null, null, null, null)
,
null
      );
    
    this.cells.ExpectedSourceShippingContainer = new GridCellModel(
      new CellStyles(['grid-table-cell-link'], null),
      this.grid.headers.ExpectedSourceShippingContainer,
      new TextModel(null, null, null, null, null)
,
null
      );
    
    this.cells.ExpectedTargetShippingContainer = new GridCellModel(
      new CellStyles(['grid-table-cell-link'], null),
      this.grid.headers.ExpectedTargetShippingContainer,
      new TextModel(null, null, null, null, null)
,
null
      );
    
    this.cells.OrderLookupCode = new GridCellModel(
      new CellStyles(['grid-table-cell-link'], null),
      this.grid.headers.OrderLookupCode,
      new TextModel(null, null, null, null, null)
,
null
      );
    
    this.cells.LoadContainerLookupCode = new GridCellModel(
      new CellStyles(['grid-table-cell-link'], null),
      this.grid.headers.LoadContainerLookupCode,
      new TextModel(null, null, null, null, null)
,
null
      );
    
    this.cells.StartDateTime = new GridCellModel(
      new CellStyles(null, null),
      this.grid.headers.StartDateTime,
      new TextModel(null, null, null, null, null)
,
null
      );
    
    this.cells.CompletedDateTime = new GridCellModel(
      new CellStyles(null, null),
      this.grid.headers.CompletedDateTime,
      new TextModel(null, null, null, null, null)
,
null
      );
    
    this.cells.Employee = new GridCellModel(
      new CellStyles(null, null),
      this.grid.headers.Employee,
      new TextModel(null, null, null, null, null)
,
null
      );
    
    this.cells.ExpectedPackagedAmount = new GridCellModel(
      new CellStyles(null, null),
      this.grid.headers.ExpectedPackagedAmount,
      new TextModel(null, null, null, null, null)
,
null
      );
    
    this.cells.ActualPackagedAmount = new GridCellModel(
      new CellStyles(null, null),
      this.grid.headers.ActualPackagedAmount,
      new TextModel(null, null, null, null, null)
,
null
      );
    
    this.cells.ActualPackaging = new GridCellModel(
      new CellStyles(null, null),
      this.grid.headers.ActualPackaging,
      new TextModel(null, null, null, null, null)
,
null
      );
    
    this.cells.WarehouseName = new GridCellModel(
      new CellStyles(null, null),
      this.grid.headers.WarehouseName,
      new TextModel(null, null, null, null, null)
,
null
      );
    
    this.cells.Notes = new GridCellModel(
      new CellStyles(null, null),
      this.grid.headers.Notes,
      new TextModel(null, null, null, null, null)
,
null
      );
    
    this.cells.ActualSourceLocation = new GridCellModel(
      new CellStyles(['grid-table-cell-link'], null),
      this.grid.headers.ActualSourceLocation,
      new TextModel(null, null, null, null, null)
,
null
      );
    
    this.cells.ActualTargetLocation = new GridCellModel(
      new CellStyles(['grid-table-cell-link'], null),
      this.grid.headers.ActualTargetLocation,
      new TextModel(null, null, null, null, null)
,
null
      );
    
    this.cells.ExpectedSourceLocation = new GridCellModel(
      new CellStyles(['grid-table-cell-link'], null),
      this.grid.headers.ExpectedSourceLocation,
      new TextModel(null, null, null, null, null)
,
null
      );
    
    this.cells.ExpectedTargetLocation = new GridCellModel(
      new CellStyles(['grid-table-cell-link'], null),
      this.grid.headers.ExpectedTargetLocation,
      new TextModel(null, null, null, null, null)
,
null
      );
    
    this.cells.CreatedDateTime = new GridCellModel(
      new CellStyles(null, null),
      this.grid.headers.CreatedDateTime,
      new TextModel(null, null, null, null, null)
,
null
      );
    
    this.cells.CreatedBy = new GridCellModel(
      new CellStyles(null, null),
      this.grid.headers.CreatedBy,
      new TextModel(null, null, null, null, null)
,
null
      );
    
    this.cells.ModifiedDateTime = new GridCellModel(
      new CellStyles(null, null),
      this.grid.headers.ModifiedDateTime,
      new TextModel(null, null, null, null, null)
,
null
      );
    
    this.cells.ModifiedBy = new GridCellModel(
      new CellStyles(null, null),
      this.grid.headers.ModifiedBy,
      new TextModel(null, null, null, null, null)
,
null
      );
    
    
  }

  async $initializeExisting(entity: IFootprintManager_shipping_container_tasks_child_gridComponentEntity) {
    this.entity = entity;

    this.rowId = [this.entity.Id].join('-');

    await this.$dataLoaded();
  }

  async $initializeNew(entity?: IFootprintManager_shipping_container_tasks_child_gridComponentEntity) {
    this.isNew = true;

    if (entity) {
      this.entity = entity;
    }
    else {
      this.entity = {};
    }

    this.rowId = [this.entity.Id].join('-');
    await this.$dataLoaded();
    // mark the whole form as dirty, since this is a new row 
    // and even if it is valid, it should have a changed state
    this.formGroup.markAsDirty();
  }

  private $unsubscribe$ = new Subject();
  override destroy(): void {
    this.$unsubscribe$.next(null);
    this.$unsubscribe$.complete();
  }

  $init() {
  }

  async $dataLoad() {
    const $row = this;
    const $grid = this.grid;
    const $utils = this.$utils;
    const $resultKey = this.entity.Id;
    const inParams = {
      $keys:[$resultKey],
      shipping_container_id:  $grid.inParams.shippingContainerId ,
      task_ids:  null ,
      date_to:  $grid.filters.date_to.control.value ,
      date_from:  $grid.filters.date_from.control.value ,
      date_type:  $grid.filters.date_type.control.value ,
      warehouse_ids:  null ,
      full_text_search:  $grid.fullTextSearch ,
      chain_head:  $grid.inParams.chainHead ,
      operation_code_ids:  null ,
      status_ids:  null ,
    };
    const data = await this.$datasources.ShippingContainers.ds_get_shipping_containers_tasks.getByKeys(inParams);
    
    await this.grid.$applyLinkedDatasourcesAndCustomColumns(inParams, data);
      
    this.entity = data.result[0] as IFootprintManager_shipping_container_tasks_child_gridComponentEntity;
    await this.$dataLoaded();
  }

  async $dataLoaded() {
    const $row = this;
    const $grid = this.grid;
    const $utils = this.$utils;
    (this.cells.Id.displayControl as TextModel).text = $row.entity.Id?.toString();
    (this.cells.OperationCode.displayControl as TextModel).text = $row.entity.OperationCode.Name;
    (this.cells.Status.displayControl as TextModel).text = $row.entity.Status.Name;
    (this.cells.Owner.displayControl as TextModel).text = $row.entity.Project?.Owner?.Name;
    (this.cells.Project.displayControl as TextModel).text = $row.entity.Project?.Name;
    (this.cells.Material.displayControl as TextModel).text = $row.entity.Material?.LookupCode;
    (this.cells.VendorLot.displayControl as TextModel).text = $row.entity.VendorLot?.LookupCode;
    (this.cells.Lot.displayControl as TextModel).text = $row.entity.Lot?.LookupCode;
    (this.cells.ActualSourceShippingContainer.displayControl as TextModel).text = $row.entity.ActualSourceShippingContainer?.LookupCode;
    (this.cells.ActualTargetShippingContainer.displayControl as TextModel).text = $row.entity.ActualTargetShippingContainer?.LookupCode;
    (this.cells.ExpectedSourceShippingContainer.displayControl as TextModel).text = $row.entity.ExpectedSourceShippingContainer?.LookupCode;
    (this.cells.ExpectedTargetShippingContainer.displayControl as TextModel).text = $row.entity.ExpectedTargetShippingContainer?.LookupCode;
    (this.cells.OrderLookupCode.displayControl as TextModel).text = $row.entity.Order?.LookupCode;
    (this.cells.LoadContainerLookupCode.displayControl as TextModel).text = $row.entity.Shipment?.LoadContainer?.LookupCode;
    (this.cells.Employee.displayControl as TextModel).text = $row.entity.Employee;
    (this.cells.ExpectedPackagedAmount.displayControl as TextModel).text = $row.entity.ExpectedPackagedAmount?.toString();
    (this.cells.ActualPackagedAmount.displayControl as TextModel).text = $row.entity.ActualPackagedAmount?.toString();
    (this.cells.ActualPackaging.displayControl as TextModel).text = $row.entity.ActualPackagedPack?.Name;
    (this.cells.WarehouseName.displayControl as TextModel).text = $row.entity.Warehouse?.Name;
    (this.cells.Notes.displayControl as TextModel).text = $row.entity.Notes;
    (this.cells.ActualSourceLocation.displayControl as TextModel).text = $row.entity.ActualSourceLocation?.Name;
    (this.cells.ActualTargetLocation.displayControl as TextModel).text = $row.entity.ActualTargetLocation?.Name;
    (this.cells.ExpectedSourceLocation.displayControl as TextModel).text = $row.entity.ExpectedSourceLocation?.Name;
    (this.cells.ExpectedTargetLocation.displayControl as TextModel).text = $row.entity.ExpectedTargetLocation?.Name;
    (this.cells.CreatedBy.displayControl as TextModel).text = $row.entity.CreatedSysUser;
    (this.cells.ModifiedBy.displayControl as TextModel).text = $row.entity.ModifiedSysUser;

    await this.on_row_data_loaded();
  }

  override async refresh() {
    if (this.grid.$hasMissingRequiredInParams) {
      return Promise.resolve(null);
    }
    await this.$dataLoad();
    // grid refresh skipSelf=true, skipParent=false, skipChildren=false  
    this.grid.$refreshEvent.emit();
  }

  override async save() {
    if (this.isNew) {
    } else {
    } 
  }

  override $cellClicked(cellId: string) {
    super.$cellClicked(cellId);
    switch(cellId) {
      case 'Project' : {
        this.on_project_clicked();
        break;
      }
      case 'Material' : {
        this.on_material_clicked();
        break;
      }
      case 'Lot' : {
        this.on_lot_clicked();
        break;
      }
      case 'ActualSourceShippingContainer' : {
        this.on_actual_source_shipping_container_clicked();
        break;
      }
      case 'ActualTargetShippingContainer' : {
        this.on_actual_target_shipping_container_clicked();
        break;
      }
      case 'ExpectedSourceShippingContainer' : {
        this.on_expected_source_shipping_container_clicked();
        break;
      }
      case 'ExpectedTargetShippingContainer' : {
        this.on_expected_target_shipping_container_clicked();
        break;
      }
      case 'OrderLookupCode' : {
        this.on_order_clicked();
        break;
      }
      case 'LoadContainerLookupCode' : {
        this.on_load_container_clicked();
        break;
      }
      case 'ActualSourceLocation' : {
        this.on_actual_source_location_clicked();
        break;
      }
      case 'ActualTargetLocation' : {
        this.on_actual_target_location_clicked();
        break;
      }
      case 'ExpectedSourceLocation' : {
        this.on_expected_source_location_clicked();
        break;
      }
      case 'ExpectedTargetLocation' : {
        this.on_expected_target_location_clicked();
        break;
      }
    }
  }

  //#region private flows
  on_row_data_loaded(event = null) {
    return this.on_row_data_loadedInternal(
      this,
  this.grid, this.$shell,
      this.$datasources,
      this.$flows,
      this.$reports,
      this.$settings,
      this.$operations,
      this.$utils,
      this.$context,
      // Localization was developed as a POC while working on a spike 123236. This $l10n is hidden for now.
      // this.localization,
      event);
  }
  async on_row_data_loadedInternal(
    $row: FootprintManager_shipping_container_tasks_child_gridComponentRowModel,
  $grid: FootprintManager_shipping_container_tasks_child_gridComponent, 
    $shell: FootprintManager_ShellService,
    $datasources: FootprintManager_DatasourceService,
    $flows: FootprintManager_FlowService,
    $reports: FootprintManager_ReportService,
    $settings: SettingsValuesService,
    $operations: FootprintManager_OperationService,
    $utils: UtilsService,
    $context: FootprintManager_shipping_container_tasks_child_grid_ComponentContextService,
    // Localization was developed as a POC while working on a spike 123236. This $l10n is hidden for now.
    //$l10n: FootprintManager_LocalizationService,
    $event: any
  ) {
  // O.Arias - 09/26/2023
  
  // Set Date/Time Formats
  const format = `${$settings.FootprintManager.DateFormat}, ${$settings.FootprintManager.TimeFormat.toUpperCase() == '24 HOUR' ? 'HH:mm' : 'LT'}`;
  
  if ($utils.isDefined(format)) {
  
      if ($utils.isDefined($row.entity.StartDateTime)) {
          $row.cells.StartDateTime.displayControl.text = $utils.date.format($row.entity.StartDateTime, format);
      };
  
      if ($utils.isDefined($row.entity.CompletedDateTime)) {
          $row.cells.CompletedDateTime.displayControl.text = $utils.date.format($row.entity.CompletedDateTime, format);
      };
  
      if ($utils.isDefined($row.entity.ModifiedSysDateTime)) {
          $row.cells.ModifiedDateTime.displayControl.text = $utils.date.format($row.entity.ModifiedSysDateTime, format);
      };
  
      if ($utils.isDefined($row.entity.CreatedSysDateTime)) {
          $row.cells.CreatedDateTime.displayControl.text = $utils.date.format($row.entity.CreatedSysDateTime, format);
      };
  
  };
  }
  on_actual_source_location_clicked(event = null) {
    return this.on_actual_source_location_clickedInternal(
      this,
  this.grid, this.$shell,
      this.$datasources,
      this.$flows,
      this.$reports,
      this.$settings,
      this.$operations,
      this.$utils,
      this.$context,
      // Localization was developed as a POC while working on a spike 123236. This $l10n is hidden for now.
      // this.localization,
      event);
  }
  async on_actual_source_location_clickedInternal(
    $row: FootprintManager_shipping_container_tasks_child_gridComponentRowModel,
  $grid: FootprintManager_shipping_container_tasks_child_gridComponent, 
    $shell: FootprintManager_ShellService,
    $datasources: FootprintManager_DatasourceService,
    $flows: FootprintManager_FlowService,
    $reports: FootprintManager_ReportService,
    $settings: SettingsValuesService,
    $operations: FootprintManager_OperationService,
    $utils: UtilsService,
    $context: FootprintManager_shipping_container_tasks_child_grid_ComponentContextService,
    // Localization was developed as a POC while working on a spike 123236. This $l10n is hidden for now.
    //$l10n: FootprintManager_LocalizationService,
    $event: any
  ) {
  if (await $operations.FootprintManager.Disable_Location_View.isAuthorized()) {
      await $shell.FootprintManager.openInfoDialog('Authorization', 'You are not authorized for this operation.');
  } else {
  
      if ($utils.isDefined($row.entity?.ActualSourceLocationId)) {
          $shell.FootprintManager.opensingle_location_hub({ locationId: $row.entity.ActualSourceLocationId });
      }
  }
  }
  on_actual_target_location_clicked(event = null) {
    return this.on_actual_target_location_clickedInternal(
      this,
  this.grid, this.$shell,
      this.$datasources,
      this.$flows,
      this.$reports,
      this.$settings,
      this.$operations,
      this.$utils,
      this.$context,
      // Localization was developed as a POC while working on a spike 123236. This $l10n is hidden for now.
      // this.localization,
      event);
  }
  async on_actual_target_location_clickedInternal(
    $row: FootprintManager_shipping_container_tasks_child_gridComponentRowModel,
  $grid: FootprintManager_shipping_container_tasks_child_gridComponent, 
    $shell: FootprintManager_ShellService,
    $datasources: FootprintManager_DatasourceService,
    $flows: FootprintManager_FlowService,
    $reports: FootprintManager_ReportService,
    $settings: SettingsValuesService,
    $operations: FootprintManager_OperationService,
    $utils: UtilsService,
    $context: FootprintManager_shipping_container_tasks_child_grid_ComponentContextService,
    // Localization was developed as a POC while working on a spike 123236. This $l10n is hidden for now.
    //$l10n: FootprintManager_LocalizationService,
    $event: any
  ) {
  if (await $operations.FootprintManager.Disable_Location_View.isAuthorized()) {
      await $shell.FootprintManager.openInfoDialog('Authorization', 'You are not authorized for this operation.');
  } else {
  
      if ($utils.isDefined($row.entity?.ActualTargetLocationId)) {
          $shell.FootprintManager.opensingle_location_hub({ locationId: $row.entity.ActualTargetLocationId });
      }
  }
  }
  on_expected_source_location_clicked(event = null) {
    return this.on_expected_source_location_clickedInternal(
      this,
  this.grid, this.$shell,
      this.$datasources,
      this.$flows,
      this.$reports,
      this.$settings,
      this.$operations,
      this.$utils,
      this.$context,
      // Localization was developed as a POC while working on a spike 123236. This $l10n is hidden for now.
      // this.localization,
      event);
  }
  async on_expected_source_location_clickedInternal(
    $row: FootprintManager_shipping_container_tasks_child_gridComponentRowModel,
  $grid: FootprintManager_shipping_container_tasks_child_gridComponent, 
    $shell: FootprintManager_ShellService,
    $datasources: FootprintManager_DatasourceService,
    $flows: FootprintManager_FlowService,
    $reports: FootprintManager_ReportService,
    $settings: SettingsValuesService,
    $operations: FootprintManager_OperationService,
    $utils: UtilsService,
    $context: FootprintManager_shipping_container_tasks_child_grid_ComponentContextService,
    // Localization was developed as a POC while working on a spike 123236. This $l10n is hidden for now.
    //$l10n: FootprintManager_LocalizationService,
    $event: any
  ) {
  if (await $operations.FootprintManager.Disable_Location_View.isAuthorized()) {
      await $shell.FootprintManager.openInfoDialog('Authorization', 'You are not authorized for this operation.');
  } else {
  
      if ($utils.isDefined($row.entity?.ExpectedSourceLocationId)) {
          $shell.FootprintManager.opensingle_location_hub({ locationId: $row.entity.ExpectedSourceLocationId });
      }
  }
  }
  on_expected_target_location_clicked(event = null) {
    return this.on_expected_target_location_clickedInternal(
      this,
  this.grid, this.$shell,
      this.$datasources,
      this.$flows,
      this.$reports,
      this.$settings,
      this.$operations,
      this.$utils,
      this.$context,
      // Localization was developed as a POC while working on a spike 123236. This $l10n is hidden for now.
      // this.localization,
      event);
  }
  async on_expected_target_location_clickedInternal(
    $row: FootprintManager_shipping_container_tasks_child_gridComponentRowModel,
  $grid: FootprintManager_shipping_container_tasks_child_gridComponent, 
    $shell: FootprintManager_ShellService,
    $datasources: FootprintManager_DatasourceService,
    $flows: FootprintManager_FlowService,
    $reports: FootprintManager_ReportService,
    $settings: SettingsValuesService,
    $operations: FootprintManager_OperationService,
    $utils: UtilsService,
    $context: FootprintManager_shipping_container_tasks_child_grid_ComponentContextService,
    // Localization was developed as a POC while working on a spike 123236. This $l10n is hidden for now.
    //$l10n: FootprintManager_LocalizationService,
    $event: any
  ) {
  if (await $operations.FootprintManager.Disable_Location_View.isAuthorized()) {
      await $shell.FootprintManager.openInfoDialog('Authorization', 'You are not authorized for this operation.');
  } else {
  
      if ($utils.isDefined($row.entity?.ExpectedTargetLocationId)) {
          $shell.FootprintManager.opensingle_location_hub({ locationId: $row.entity.ExpectedTargetLocationId });
      }
  }
  }
  on_actual_source_shipping_container_clicked(event = null) {
    return this.on_actual_source_shipping_container_clickedInternal(
      this,
  this.grid, this.$shell,
      this.$datasources,
      this.$flows,
      this.$reports,
      this.$settings,
      this.$operations,
      this.$utils,
      this.$context,
      // Localization was developed as a POC while working on a spike 123236. This $l10n is hidden for now.
      // this.localization,
      event);
  }
  async on_actual_source_shipping_container_clickedInternal(
    $row: FootprintManager_shipping_container_tasks_child_gridComponentRowModel,
  $grid: FootprintManager_shipping_container_tasks_child_gridComponent, 
    $shell: FootprintManager_ShellService,
    $datasources: FootprintManager_DatasourceService,
    $flows: FootprintManager_FlowService,
    $reports: FootprintManager_ReportService,
    $settings: SettingsValuesService,
    $operations: FootprintManager_OperationService,
    $utils: UtilsService,
    $context: FootprintManager_shipping_container_tasks_child_grid_ComponentContextService,
    // Localization was developed as a POC while working on a spike 123236. This $l10n is hidden for now.
    //$l10n: FootprintManager_LocalizationService,
    $event: any
  ) {
  if ($utils.isDefined($row.entity?.ActualSourceShippingContainerId)) {
      if ($row.entity.ActualSourceShippingContainerId !== $grid.inParams.shippingContainerId) {
          $shell.FootprintManager.openshipping_container_editor({ shippingContainerId: $row.entity.ActualSourceShippingContainerId });
      };
  };
  }
  on_actual_target_shipping_container_clicked(event = null) {
    return this.on_actual_target_shipping_container_clickedInternal(
      this,
  this.grid, this.$shell,
      this.$datasources,
      this.$flows,
      this.$reports,
      this.$settings,
      this.$operations,
      this.$utils,
      this.$context,
      // Localization was developed as a POC while working on a spike 123236. This $l10n is hidden for now.
      // this.localization,
      event);
  }
  async on_actual_target_shipping_container_clickedInternal(
    $row: FootprintManager_shipping_container_tasks_child_gridComponentRowModel,
  $grid: FootprintManager_shipping_container_tasks_child_gridComponent, 
    $shell: FootprintManager_ShellService,
    $datasources: FootprintManager_DatasourceService,
    $flows: FootprintManager_FlowService,
    $reports: FootprintManager_ReportService,
    $settings: SettingsValuesService,
    $operations: FootprintManager_OperationService,
    $utils: UtilsService,
    $context: FootprintManager_shipping_container_tasks_child_grid_ComponentContextService,
    // Localization was developed as a POC while working on a spike 123236. This $l10n is hidden for now.
    //$l10n: FootprintManager_LocalizationService,
    $event: any
  ) {
  if ($utils.isDefined($row.entity?.ActualTargetShippingContainerId)) {
      if ($row.entity.ActualTargetShippingContainerId !== $grid.inParams.shippingContainerId) {
          $shell.FootprintManager.openshipping_container_editor({ shippingContainerId: $row.entity.ActualTargetShippingContainerId });
      };
  };
  }
  on_expected_source_shipping_container_clicked(event = null) {
    return this.on_expected_source_shipping_container_clickedInternal(
      this,
  this.grid, this.$shell,
      this.$datasources,
      this.$flows,
      this.$reports,
      this.$settings,
      this.$operations,
      this.$utils,
      this.$context,
      // Localization was developed as a POC while working on a spike 123236. This $l10n is hidden for now.
      // this.localization,
      event);
  }
  async on_expected_source_shipping_container_clickedInternal(
    $row: FootprintManager_shipping_container_tasks_child_gridComponentRowModel,
  $grid: FootprintManager_shipping_container_tasks_child_gridComponent, 
    $shell: FootprintManager_ShellService,
    $datasources: FootprintManager_DatasourceService,
    $flows: FootprintManager_FlowService,
    $reports: FootprintManager_ReportService,
    $settings: SettingsValuesService,
    $operations: FootprintManager_OperationService,
    $utils: UtilsService,
    $context: FootprintManager_shipping_container_tasks_child_grid_ComponentContextService,
    // Localization was developed as a POC while working on a spike 123236. This $l10n is hidden for now.
    //$l10n: FootprintManager_LocalizationService,
    $event: any
  ) {
  if ($utils.isDefined($row.entity?.ExpectedSourceShippingContainerId)) {
      if ($row.entity.ExpectedSourceShippingContainerId !== $grid.inParams.shippingContainerId) {
          $shell.FootprintManager.openshipping_container_editor({ shippingContainerId: $row.entity.ExpectedSourceShippingContainerId });
      };
  };
  }
  on_expected_target_shipping_container_clicked(event = null) {
    return this.on_expected_target_shipping_container_clickedInternal(
      this,
  this.grid, this.$shell,
      this.$datasources,
      this.$flows,
      this.$reports,
      this.$settings,
      this.$operations,
      this.$utils,
      this.$context,
      // Localization was developed as a POC while working on a spike 123236. This $l10n is hidden for now.
      // this.localization,
      event);
  }
  async on_expected_target_shipping_container_clickedInternal(
    $row: FootprintManager_shipping_container_tasks_child_gridComponentRowModel,
  $grid: FootprintManager_shipping_container_tasks_child_gridComponent, 
    $shell: FootprintManager_ShellService,
    $datasources: FootprintManager_DatasourceService,
    $flows: FootprintManager_FlowService,
    $reports: FootprintManager_ReportService,
    $settings: SettingsValuesService,
    $operations: FootprintManager_OperationService,
    $utils: UtilsService,
    $context: FootprintManager_shipping_container_tasks_child_grid_ComponentContextService,
    // Localization was developed as a POC while working on a spike 123236. This $l10n is hidden for now.
    //$l10n: FootprintManager_LocalizationService,
    $event: any
  ) {
  if ($utils.isDefined($row.entity?.ExpectedTargetShippingContainerId)) {
      if ($row.entity.ExpectedTargetShippingContainerId !== $grid.inParams.shippingContainerId) {
          $shell.FootprintManager.openshipping_container_editor({ shippingContainerId: $row.entity.ExpectedTargetShippingContainerId });
      };
  };
  }
  on_lot_clicked(event = null) {
    return this.on_lot_clickedInternal(
      this,
  this.grid, this.$shell,
      this.$datasources,
      this.$flows,
      this.$reports,
      this.$settings,
      this.$operations,
      this.$utils,
      this.$context,
      // Localization was developed as a POC while working on a spike 123236. This $l10n is hidden for now.
      // this.localization,
      event);
  }
  async on_lot_clickedInternal(
    $row: FootprintManager_shipping_container_tasks_child_gridComponentRowModel,
  $grid: FootprintManager_shipping_container_tasks_child_gridComponent, 
    $shell: FootprintManager_ShellService,
    $datasources: FootprintManager_DatasourceService,
    $flows: FootprintManager_FlowService,
    $reports: FootprintManager_ReportService,
    $settings: SettingsValuesService,
    $operations: FootprintManager_OperationService,
    $utils: UtilsService,
    $context: FootprintManager_shipping_container_tasks_child_grid_ComponentContextService,
    // Localization was developed as a POC while working on a spike 123236. This $l10n is hidden for now.
    //$l10n: FootprintManager_LocalizationService,
    $event: any
  ) {
  if (await $operations.FootprintManager.Disable_Lot_View.isAuthorized()) {
      await $shell.FootprintManager.openInfoDialog('Authorization', 'You are not authorized for this operation.');
  } else {
  
      if ($utils.isDefined($row.entity?.LotId)) {
          $shell.FootprintManager.opensingle_lot_hub({ lotId: $row.entity.LotId });
      };
  }
  }
  on_material_clicked(event = null) {
    return this.on_material_clickedInternal(
      this,
  this.grid, this.$shell,
      this.$datasources,
      this.$flows,
      this.$reports,
      this.$settings,
      this.$operations,
      this.$utils,
      this.$context,
      // Localization was developed as a POC while working on a spike 123236. This $l10n is hidden for now.
      // this.localization,
      event);
  }
  async on_material_clickedInternal(
    $row: FootprintManager_shipping_container_tasks_child_gridComponentRowModel,
  $grid: FootprintManager_shipping_container_tasks_child_gridComponent, 
    $shell: FootprintManager_ShellService,
    $datasources: FootprintManager_DatasourceService,
    $flows: FootprintManager_FlowService,
    $reports: FootprintManager_ReportService,
    $settings: SettingsValuesService,
    $operations: FootprintManager_OperationService,
    $utils: UtilsService,
    $context: FootprintManager_shipping_container_tasks_child_grid_ComponentContextService,
    // Localization was developed as a POC while working on a spike 123236. This $l10n is hidden for now.
    //$l10n: FootprintManager_LocalizationService,
    $event: any
  ) {
  if (await $operations.FootprintManager.Disable_Material_View.isAuthorized()) {
      await $shell.FootprintManager.openInfoDialog('Authorization', 'You are not authorized for this operation.');
  } else {
  
      if ($utils.isDefined($row.entity?.MaterialId)) {
          $shell.FootprintManager.opensingle_material_hub({ materialId: $row.entity.MaterialId });
      };
  }
  }
  on_project_clicked(event = null) {
    return this.on_project_clickedInternal(
      this,
  this.grid, this.$shell,
      this.$datasources,
      this.$flows,
      this.$reports,
      this.$settings,
      this.$operations,
      this.$utils,
      this.$context,
      // Localization was developed as a POC while working on a spike 123236. This $l10n is hidden for now.
      // this.localization,
      event);
  }
  async on_project_clickedInternal(
    $row: FootprintManager_shipping_container_tasks_child_gridComponentRowModel,
  $grid: FootprintManager_shipping_container_tasks_child_gridComponent, 
    $shell: FootprintManager_ShellService,
    $datasources: FootprintManager_DatasourceService,
    $flows: FootprintManager_FlowService,
    $reports: FootprintManager_ReportService,
    $settings: SettingsValuesService,
    $operations: FootprintManager_OperationService,
    $utils: UtilsService,
    $context: FootprintManager_shipping_container_tasks_child_grid_ComponentContextService,
    // Localization was developed as a POC while working on a spike 123236. This $l10n is hidden for now.
    //$l10n: FootprintManager_LocalizationService,
    $event: any
  ) {
  if (await $operations.FootprintManager.Disable_Project_View.isAuthorized()) {
      await $shell.FootprintManager.openInfoDialog('Authorization', 'You are not authorized for this operation.');
  } else {
  
      if ($utils.isDefined($row.entity?.ProjectId)) {
          $shell.FootprintManager.opensingle_project_hub({ projectId: $row.entity.ProjectId });
      };
  }
  }
  on_order_clicked(event = null) {
    return this.on_order_clickedInternal(
      this,
  this.grid, this.$shell,
      this.$datasources,
      this.$flows,
      this.$reports,
      this.$settings,
      this.$operations,
      this.$utils,
      this.$context,
      // Localization was developed as a POC while working on a spike 123236. This $l10n is hidden for now.
      // this.localization,
      event);
  }
  async on_order_clickedInternal(
    $row: FootprintManager_shipping_container_tasks_child_gridComponentRowModel,
  $grid: FootprintManager_shipping_container_tasks_child_gridComponent, 
    $shell: FootprintManager_ShellService,
    $datasources: FootprintManager_DatasourceService,
    $flows: FootprintManager_FlowService,
    $reports: FootprintManager_ReportService,
    $settings: SettingsValuesService,
    $operations: FootprintManager_OperationService,
    $utils: UtilsService,
    $context: FootprintManager_shipping_container_tasks_child_grid_ComponentContextService,
    // Localization was developed as a POC while working on a spike 123236. This $l10n is hidden for now.
    //$l10n: FootprintManager_LocalizationService,
    $event: any
  ) {
  if ($utils.isDefined($row.entity?.OrderId)) {
  
      let order = (await $datasources.AsnOrders.ds_asn_order_editor.get({ orderId: $row.entity.OrderId })).result;
      let order_class = -1;
  
      if ($utils.isDefined(order)) {
          order_class = order.OrderClassId;
      };
  
      if (order_class === 1) {
          $shell.FootprintManager.openpurchase_order_editor({ orderId: $row.entity.OrderId });
      } else if (order_class === 14) {
          $shell.FootprintManager.openasn_order_editor({ order_id: $row.entity.OrderId });
      } else {
          $shell.FootprintManager.opensales_order_editor({ orderId: $row.entity.OrderId });
      };
  };
  }
  on_load_container_clicked(event = null) {
    return this.on_load_container_clickedInternal(
      this,
  this.grid, this.$shell,
      this.$datasources,
      this.$flows,
      this.$reports,
      this.$settings,
      this.$operations,
      this.$utils,
      this.$context,
      // Localization was developed as a POC while working on a spike 123236. This $l10n is hidden for now.
      // this.localization,
      event);
  }
  async on_load_container_clickedInternal(
    $row: FootprintManager_shipping_container_tasks_child_gridComponentRowModel,
  $grid: FootprintManager_shipping_container_tasks_child_gridComponent, 
    $shell: FootprintManager_ShellService,
    $datasources: FootprintManager_DatasourceService,
    $flows: FootprintManager_FlowService,
    $reports: FootprintManager_ReportService,
    $settings: SettingsValuesService,
    $operations: FootprintManager_OperationService,
    $utils: UtilsService,
    $context: FootprintManager_shipping_container_tasks_child_grid_ComponentContextService,
    // Localization was developed as a POC while working on a spike 123236. This $l10n is hidden for now.
    //$l10n: FootprintManager_LocalizationService,
    $event: any
  ) {
  if ($utils.isDefined($row.entity?.Shipment?.LoadContainerId)) {
          $shell.FootprintManager.openload_container_editor({ loadContainerId: $row.entity.Shipment?.LoadContainerId });
  };
  }
  //#endregion private flows

}


@Component({
  standalone: true,
  imports: [
    SharedModule,
    forwardRef(() => ShippingContainers_task_dates_dd_singleComponent),
  ],
  selector: 'FootprintManager-shipping_container_tasks_child_grid',
  templateUrl: './FootprintManager.shipping_container_tasks_child_grid.component.html'
})
export class FootprintManager_shipping_container_tasks_child_gridComponent extends BaseComponent implements OnInit, OnChanges, OnDestroy {
  //#region Outputs
  @Output()
  $finish = new EventEmitter();
  @Output()
  $refreshEvent = new EventEmitter();
  //#endregion Outputs

  entities: IFootprintManager_shipping_container_tasks_child_gridComponentEntity[];

  pageSize = 10;
  pageSkip = 0;
  totalCount = 0;
  loadingStatus = ELoadingStatus.Loading;


// to stop add from flow
// canAdd = false; //hide add button, check on exitFromLastCell 
// bottomToolbar.addLine.hidden = true; //hide add button, no check on exitFromLastCell 
// bottomToolbar.addLine.control.readOnly = true; //disable add button, check on exitFromLastCell 
 
  
  containerStyles: GridContainerStyle = new GridContainerStyle('cellsWidth', ['fit-content-table']);

  fullTextSearch: string;

  inParams: IFootprintManager_shipping_container_tasks_child_gridComponentInParams = { shippingContainerId: null, chainHead: null };


  //#region Variables
  //#endregion
  //#region Events
  
  //#endregion

  headers = {
     Id: new GridHeaderModel(new HeaderStyles(null, null), 'Id', 'Id', false, false, null, false),       OperationCode: new GridHeaderModel(new HeaderStyles(null, null), 'OperationCode', 'Operation', false, false, null, false),       Status: new GridHeaderModel(new HeaderStyles(null, null), 'Status', 'Status', false, false, null, false),       Owner: new GridHeaderModel(new HeaderStyles(null, null), 'Owner', 'Owner', false, false, null, false),       Project: new GridHeaderModel(new HeaderStyles(null, null), 'Project', 'Project', false, false, null, false),       Material: new GridHeaderModel(new HeaderStyles(null, null), 'Material', 'Material', false, false, null, false),       VendorLot: new GridHeaderModel(new HeaderStyles(null, null), 'VendorLot', 'Vendor lot', false, false, null, false),       Lot: new GridHeaderModel(new HeaderStyles(null, null), 'Lot', 'Lot', false, false, null, false),       ActualSourceShippingContainer: new GridHeaderModel(new HeaderStyles(null, null), 'ActualSourceShippingContainer', 'Actual source shipping container', false, false, null, false),       ActualTargetShippingContainer: new GridHeaderModel(new HeaderStyles(null, null), 'ActualTargetShippingContainer', 'Actual target shipping container', false, false, null, false),       ExpectedSourceShippingContainer: new GridHeaderModel(new HeaderStyles(null, null), 'ExpectedSourceShippingContainer', 'Expected source shipping container', false, false, null, false),       ExpectedTargetShippingContainer: new GridHeaderModel(new HeaderStyles(null, null), 'ExpectedTargetShippingContainer', 'Expected target shipping container', false, false, null, false),       OrderLookupCode: new GridHeaderModel(new HeaderStyles(null, null), 'OrderLookupCode', 'Order', false, false, null, false),       LoadContainerLookupCode: new GridHeaderModel(new HeaderStyles(null, null), 'LoadContainerLookupCode', 'Load container', false, false, null, false),       StartDateTime: new GridHeaderModel(new HeaderStyles(null, null), 'StartDateTime', 'Start date', false, false, null, false),       CompletedDateTime: new GridHeaderModel(new HeaderStyles(null, null), 'CompletedDateTime', 'Completed date', false, false, null, false),       Employee: new GridHeaderModel(new HeaderStyles(null, null), 'Employee', 'Employee', false, false, null, false),       ExpectedPackagedAmount: new GridHeaderModel(new HeaderStyles(null, null), 'ExpectedPackagedAmount', 'Expected packaged amount', false, false, null, false),       ActualPackagedAmount: new GridHeaderModel(new HeaderStyles(null, null), 'ActualPackagedAmount', 'Actual packaged amount', false, false, null, false),       ActualPackaging: new GridHeaderModel(new HeaderStyles(null, null), 'ActualPackaging', 'Actual packaging', false, false, null, false),       WarehouseName: new GridHeaderModel(new HeaderStyles(null, null), 'WarehouseName', 'Warehouse', false, false, null, false),       Notes: new GridHeaderModel(new HeaderStyles(null, null), 'Notes', 'Notes', false, false, null, false),       ActualSourceLocation: new GridHeaderModel(new HeaderStyles(null, null), 'ActualSourceLocation', 'Actual source location', false, false, null, false),       ActualTargetLocation: new GridHeaderModel(new HeaderStyles(null, null), 'ActualTargetLocation', 'Actual target location', false, false, null, false),       ExpectedSourceLocation: new GridHeaderModel(new HeaderStyles(null, null), 'ExpectedSourceLocation', 'Expected source location', false, false, null, false),       ExpectedTargetLocation: new GridHeaderModel(new HeaderStyles(null, null), 'ExpectedTargetLocation', 'Expected target location', false, false, null, false),       CreatedDateTime: new GridHeaderModel(new HeaderStyles(null, null), 'CreatedDateTime', 'Created date', false, false, null, false),       CreatedBy: new GridHeaderModel(new HeaderStyles(null, null), 'CreatedBy', 'Created by', false, false, null, false),       ModifiedDateTime: new GridHeaderModel(new HeaderStyles(null, null), 'ModifiedDateTime', 'Modified date', false, false, null, false),       ModifiedBy: new GridHeaderModel(new HeaderStyles(null, null), 'ModifiedBy', 'Modified by', false, false, null, false),  
  };

  //#region title
  // Make it async so that it won't cause expressionChangedAfterItHasBeenCheckedError
  // The title is often meant to be shown from the parent (shell breadcrumb for example)
  // and often it will cause an expressionChangedAfterItHasBeenCheckedError because 
  // the parent has already been checked and the child now change something on the parent 
  // in dev, CD is run twice
  $titleChange = new EventEmitter<string>(true);
  private $_title: string;
  get title(): string {
    return this.$_title;
  }
  set title(t: string) {
    this.$_title = t;
    this.$titleChange.emit(this.$_title);
  }
  //#endregion title
  rows: FootprintManager_shipping_container_tasks_child_gridComponentRowModel[] = [];

  @Input('shippingContainerId') set $inParams_shippingContainerId(value: any) {
    this.inParams['shippingContainerId'] = value;
  }
  get $inParams_shippingContainerId(): any {
    return this.inParams['shippingContainerId'] ;
  }
  @Input('chainHead') set $inParams_chainHead(value: any) {
    this.inParams['chainHead'] = value;
  }
  get $inParams_chainHead(): any {
    return this.inParams['chainHead'] ;
  }

  topToolbar = {
  };

  bottomToolbar = {
  };

  formGroup: FormGroup = new FormGroup({
    date_from: new DatexFormControl(null, { validators: [  ], updateOn: 'blur' }),
    date_to: new DatexFormControl(null, { validators: [  ], updateOn: 'blur' }),
    date_type: new DatexFormControl(null, { validators: [  ], updateOn: 'blur' }),
  });

  filters = {
    date_from: new FieldModel(new DateBoxModel(this.formGroup.controls['date_from'] as DatexFormControl, null, false, false, 'l, LT', 'datetime', null)
, new ControlContainerStyles(null, null), 'Date from', false, false),
    date_to: new FieldModel(new DateBoxModel(this.formGroup.controls['date_to'] as DatexFormControl, null, false, false, 'l, LT', 'datetime', null)
, new ControlContainerStyles(null, null), 'Date to', false, false),
    date_type: new FieldModel(new SelectBoxModel(
  this.formGroup.controls['date_type'] as DatexFormControl, 
  ESelectBoxType.dropdown, null,
  false,
  false,
  '', null)
, new ControlContainerStyles(null, null), 'Date type', false, false),
  }

  //#region filters inParams
  //#endregion filters inParams


  constructor(
    private $utils: UtilsService,
    private $settings: SettingsValuesService,
    private $shell: FootprintManager_ShellService,
    private $datasources: FootprintManager_DatasourceService,
    private $flows: FootprintManager_FlowService,
    private $reports: FootprintManager_ReportService,
    private $localization: FootprintManager_LocalizationService,
    private $operations: FootprintManager_OperationService,
    private $logger: CleanupLoggerService,
    private $context: FootprintManager_shipping_container_tasks_child_grid_ComponentContextService,
    ) {
    super();
    this.title = 'Shipping container child tasks';
    this.$subscribeFormControlValueChanges();
  }

  ngOnInit(): void {
    this.$checkRequiredInParams();
    if (!this.$hasMissingRequiredInParams) {
      this.$init();
    } else {
      this.$initEmpty();
    }
  }
  
  private $isFirstNgOnChanges = true;
  ngOnChanges(changes: SimpleChanges): void {
    if (this.$isFirstNgOnChanges) {
      this.$isFirstNgOnChanges = false;
    } else {
      this.$checkRequiredInParams();
      if(!this.$hasMissingRequiredInParams) {
        this.$init();
      } else {
        this.$initEmpty();
      }
    }
  }

  $missingRequiredInParams = [];
  get $hasMissingRequiredInParams(): boolean {
    return !!this.$missingRequiredInParams.length;
  }
  
  $checkRequiredInParams() {
    this.$missingRequiredInParams = [];
      if(isNil(this.inParams.shippingContainerId)) {
        this.$missingRequiredInParams.push('shippingContainerId');
      }
  }

  initialized = false;

  private $unsubscribe$ = new Subject();
  ngOnDestroy(): void {
    this.$unsubscribe$.next(null);
    this.$unsubscribe$.complete();

    this.clearRows();
  }

  async $init() {
    const $grid = this;
    const $utils = this.$utils;

    this.pageSize = 25;


    this.initialized = true;

    this.pageSkip = 0;
    this.refresh(true, true, null);
  }

  protected override $initEmpty() {
    this.clearRows();
  }

  private $subscribeFormControlValueChanges() {

    this.formGroup.valueChanges.pipe(takeUntil(this.$unsubscribe$)).subscribe(value => {
      this.reload();
    });
  }

  reload() {
    this.pageSkip = 0;
    this.refresh();
  }

  refresh(
    skipParent = false,
    skipChildren = false,
    childToSkip: string = null) {
    if (this.$hasMissingRequiredInParams) {
      return Promise.resolve(null);
    }
    // up
    if (skipParent === false) {
      this.$refreshEvent.emit();
    }

    // self
    const result = this.$dataLoad();

    // children
    if (skipChildren === false) {
    }

    return result;
  }

  async $dataLoad() {
    this.loadingStatus = ELoadingStatus.Loading;
    if(!this.formGroup.valid) {
      return;
    }
    const $grid = this;
    const $utils = this.$utils;
    const inParams = {
      $top: this.pageSize,
      $skip: this.pageSkip,
      shipping_container_id:  $grid.inParams.shippingContainerId ,
      task_ids:  null ,
      date_to:  $grid.filters.date_to.control.value ,
      date_from:  $grid.filters.date_from.control.value ,
      date_type:  $grid.filters.date_type.control.value ,
      warehouse_ids:  null ,
      full_text_search:  $grid.fullTextSearch ,
      chain_head:  $grid.inParams.chainHead ,
      operation_code_ids:  null ,
      status_ids:  null ,
    };
    try {
      const data = await this.$datasources.ShippingContainers.ds_get_shipping_containers_tasks.getList(inParams);
      
      await this.$applyLinkedDatasourcesAndCustomColumns(inParams, data);

      this.entities = data.result as IFootprintManager_shipping_container_tasks_child_gridComponentEntity[];
      this.totalCount = data.totalCount;

      await this.$dataLoaded();
      if (this.totalCount === 0) {
        this.loadingStatus = ELoadingStatus.NoResults;
      } else {
        this.loadingStatus = ELoadingStatus.Loaded;
      }
    } catch(error) {
      console.error("Error loading data:", error);
      this.loadingStatus = ELoadingStatus.Error;
    }
  }

  async $dataLoaded() {
    const $grid = this;
    const $utils = this.$utils;
    
    this.clearRows();

    if(this.entities) {
      let rowLoadPromises = [];
      for (let entity of this.entities) {
        const row = new FootprintManager_shipping_container_tasks_child_gridComponentRowModel(
          this,
          this.$utils,
          this.$settings,
          this.$shell, 
          this.$datasources,
          this.$flows,
          this.$reports,
          this.$localization,
          this.$operations,
          this.$logger,
          this.$context);
        rowLoadPromises.push(row.$initializeExisting(entity));
        this.rows.push(row);
      }
      await Promise.all(rowLoadPromises);
    }

  }

  
    async $applyLinkedDatasourcesAndCustomColumns(inParams: any, outParams: any) {
      const $datasource = { inParams: inParams };
      const $utils = this.$utils;
  
    }

  clearRows() {
    if(this.rows && this.rows.length) {
      this.rows.forEach(r => r.destroy());
    }
    this.rows = [];
  }


  
  openImageViewer(imageSource: string) {
    this.$shell.openImageViewerDialog(imageSource);
  }



 
  close() {
    this.$finish.emit();
  }
}
